import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useWorkspace } from '../lib/WorkspaceContext'

const CATEGORIAS = [
  { tipo: 'progreso', label: 'Progreso' },
  { tipo: 'diario', label: 'Registro' },
  { tipo: 'habitos', label: 'Hábitos' }
]

function formatearFecha(fechaStr) {
  return new Date(fechaStr + 'T00:00:00').toLocaleDateString('es-AR')
}

export default function MiPrivacidad({ usuario }) {
  const { workspaces } = useWorkspace()
  const workspacesPaciente = workspaces.filter(w => w.rolEnWorkspace === 'paciente')

  const [filas, setFilas] = useState({})
  const [cargando, setCargando] = useState(true)
  const [pendiente, setPendiente] = useState(null)

  useEffect(() => {
    if (workspacesPaciente.length === 0) { setCargando(false); return }
    cargar()
  }, [])

  const cargar = async () => {
    setCargando(true)
    const { data, error } = await supabase
      .from('compartidos_con_workspace')
      .select('*')
      .eq('usuario_id', usuario.id)
      .order('creado_en', { ascending: false })
    if (error) console.error('Error al cargar permisos de privacidad:', error)

    const mapa = {}
    for (const fila of data ?? []) {
      const clave = `${fila.workspace_id}:${fila.tipo_dato}`
      if (!mapa[clave]) mapa[clave] = fila
    }
    setFilas(mapa)
    setCargando(false)
  }

  const activar = async (workspaceId, tipo) => {
    const clave = `${workspaceId}:${tipo}`
    const hoy = new Date().toISOString().slice(0, 10)
    const { data, error } = await supabase
      .from('compartidos_con_workspace')
      .insert({
        usuario_id: usuario.id,
        workspace_id: workspaceId,
        tipo_dato: tipo,
        activo: true,
        fecha_desde: hoy
      })
      .select()
      .single()
    if (error) { console.error('Error al activar el permiso de privacidad:', error); return }
    setFilas(prev => ({ ...prev, [clave]: data }))
  }

  const revocar = async () => {
    if (!pendiente) return
    const { workspaceId, tipo, fila } = pendiente
    const clave = `${workspaceId}:${tipo}`
    const { error } = await supabase
      .from('compartidos_con_workspace')
      .update({ activo: false, revocado_en: new Date().toISOString() })
      .eq('id', fila.id)
    if (error) { console.error('Error al revocar el permiso de privacidad:', error); setPendiente(null); return }
    setFilas(prev => ({ ...prev, [clave]: { ...fila, activo: false, revocado_en: new Date().toISOString() } }))
    setPendiente(null)
  }

  if (workspacesPaciente.length === 0) return null
  if (cargando) return null

  return (
    <div className="perfil-seccion">
      <p className="seccion-titulo">🔒 Mi privacidad</p>
      <div className="privacidad-lista">
        {workspacesPaciente.map(ws => (
          <div key={ws.id} className="privacidad-card">
            <p className="privacidad-workspace-nombre">{ws.nombre}</p>
            {CATEGORIAS.map(cat => {
              const fila = filas[`${ws.id}:${cat.tipo}`]
              const activo = fila?.activo === true
              return (
                <div key={cat.tipo} className="privacidad-fila">
                  <div>
                    <p className="privacidad-categoria">{cat.label}</p>
                    <p className="privacidad-estado">
                      {activo
                        ? `Compartiendo desde ${fila.fecha_desde ? formatearFecha(fila.fecha_desde) : new Date(fila.creado_en).toLocaleDateString('es-AR')}`
                        : `No estás compartiendo tu ${cat.label.toLowerCase()}`}
                    </p>
                  </div>
                  <button
                    className={`privacidad-toggle ${activo ? 'activo' : ''}`}
                    onClick={() => activo
                      ? setPendiente({ workspaceId: ws.id, tipo: cat.tipo, fila })
                      : activar(ws.id, cat.tipo)}
                    aria-label={activo ? `Revocar acceso a ${cat.label}` : `Compartir ${cat.label}`}
                  >
                    <span className="privacidad-toggle-bola" />
                  </button>
                </div>
              )
            })}
          </div>
        ))}
      </div>

      {pendiente && (
        <div className="modal-overlay" onClick={() => setPendiente(null)}>
          <div className="modal-card" onClick={e => e.stopPropagation()}>
            <h3 className="modal-titulo">Revocar acceso a {CATEGORIAS.find(c => c.tipo === pendiente.tipo)?.label}</h3>
            <p style={{ fontSize: 14, color: 'var(--gris)', marginBottom: 12 }}>
              A partir de ahora, {workspacesPaciente.find(w => w.id === pendiente.workspaceId)?.nombre} va a dejar de poder ver tu {CATEGORIAS.find(c => c.tipo === pendiente.tipo)?.label.toLowerCase()}, incluido lo que ya habías compartido antes. Tus datos no se borran — vos seguís viéndolos igual que siempre, y podés volver a compartirlo cuando quieras.
            </p>
            <div className="modal-actions">
              <button className="btn-secundario" onClick={() => setPendiente(null)}>Cancelar</button>
              <button className="btn-primario" style={{ background: '#C0392B' }} onClick={revocar}>
                Revocar acceso
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
